import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatInputModule } from '@angular/material/input'
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatInputModule,
    MatListModule,
    MatRadioModule,
    MatButtonModule,
    MatExpansionModule,
    MatTableModule,
    MatToolbarModule,
    MatCardModule,
    MatSidenavModule,
    MatStepperModule,
    MatDividerModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatTabsModule,
    MatIconModule,
  ],
  exports: [
    CommonModule,
    MatInputModule,
    MatListModule,
    MatRadioModule,
    MatButtonModule,
    MatExpansionModule,
    MatTableModule,
    MatToolbarModule,
    MatCardModule,
    MatSidenavModule,
    MatStepperModule,
    MatDividerModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatTabsModule,
    MatIconModule,
  ]
})
export class MaterialModule { }
